import ServerApi from "./../../../libs/api-services/server-api"

class LocationNameService extends ServerApi {
  URL_PREFIX = "/v1/secure/user/location-names/"
}

export const locationNameService = new LocationNameService()
